import React, { useState, FormEvent, useEffect, useMemo } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Stack, Paper, Container } from '@mui/material'
import ProgressButton from '../../Utils/ProgressButton'
import { entityTextField } from '../../Utils/EntityField'
import { AppState } from '../../../reducers/index'
import { ProductSubgroupDetailState } from '../../../reducers/product/productSubgroupDetail'
import { upsertProductSubgroup } from '../../../actions/product/productSubgroupUpsert'
import ProductSubgroup from '../../../models/ProductSubgroup'
import { useTranslation } from 'react-i18next'
import { ISTableTitle } from '../../Utils/ISTable'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { fetchProductSubgroup } from '../../../actions/product/productSubgroupDetail'
import { BackButton } from '../../Utils/BackButton'
import Selector from '../../Selector'
import { isNil } from 'ramda'

interface Props {
  productSubgroup: ProductSubgroupDetailState
}

const empty: ProductSubgroup = {
  id: null,
  code: '',
  description: '',
  order: 0,
  ownerId: 0,
  ownerName: '',
  active: true
}

const ProductSubgroupUpsert: React.FC<Props> = ({ productSubgroup }) => {
  const [changed, setChanged] = useState<boolean>(false)
  const [productSubgroupInfo, setProductSubgroupInfo] = useState<ProductSubgroup>(productSubgroup.productSubgroup || empty)
  const { t } = useTranslation('product')
  const dispatch = useDispatch()
  const params = useParams<{ productSubgroupId: string }>()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (params.productSubgroupId) {
      dispatch(fetchProductSubgroup(params.productSubgroupId))
    }
  }, [dispatch, params.productSubgroupId])


  const change = (newProductSubgroupInfo: ProductSubgroup) => {
    setProductSubgroupInfo(newProductSubgroupInfo)
    setChanged(true)
  }

  const changeProductSubgroup = async (event: FormEvent) => {
    event.preventDefault()
    try {
      await dispatch(upsertProductSubgroup(productSubgroupInfo))
      setChanged(false)
      if (location.state)
        (location.state as any).update = !(location.state as any).update
      history.goBack()
    }
    catch {
    }
  }

  useEffect(() => {
    if (productSubgroup.productSubgroup) {
      setProductSubgroupInfo(params.productSubgroupId ? productSubgroup.productSubgroup : empty)
    }
  }, [productSubgroup.productSubgroup, params.productSubgroupId])

  const ProductSubgroupInfoField = useMemo(() => entityTextField(change), [])

  return (
    <Container>
      <Paper style={{ borderRadius: "10px", margin: "10px" }}>
        <ISTableTitle title={t('subgroups')}/>
        <Paper style={{ padding: "10px" }}>
          <form onSubmit={changeProductSubgroup}>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ProductSubgroupInfoField
                style={{ width: "200px", marginRight: "10px" }}
                key="code"
                variant="outlined"
                label={t("code")}
                entity={productSubgroupInfo}
                attr="code"
                size="medium"
              />
              <ProductSubgroupInfoField
                //style={{ width: "100%"}}
                key="description"
                variant="outlined"
                label={t("description")}
                entity={productSubgroupInfo}
                attr="description"
                size="medium"
              />
            </Stack>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ProductSubgroupInfoField
                style={{ marginRight: "10px" }}
                key="order"
                variant="outlined"
                label={t("order")}
                entity={productSubgroupInfo}
                attr='order'
                size="medium"
              />
              <Selector
                key="active"
                label={t("active")}
                style={{ width: "100%" }}
                value={isNil(productSubgroupInfo.active) ? "" : Boolean(productSubgroupInfo.active)}
                textAdapter={(_value) => Boolean(_value) ? t("yes") : t("no")}
                menuItems={[true, false]}
              />
            </Stack>
            <Stack display="flex" flexDirection='row' justifyContent="space-between">
              <BackButton />
              <ProgressButton state={productSubgroup} disabled={!changed}>
                {t('save')}
              </ProgressButton>
            </Stack>
          </form>
        </Paper>
      </Paper>
    </Container>

  )
}

const mapStateToProps = (state: AppState) => ({
  productSubgroup: state.productSubgroupDetail
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(ProductSubgroupUpsert)
